"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDepGraph = void 0;
const dep_graph_1 = require("@snyk/dep-graph");
const dependency_1 = require("./dependency");
function buildDepGraph(mavenGraph, includeTestScope = false, verboseEnabled = false) {
    const { rootId, nodes } = mavenGraph;
    const parsedRoot = parseId(rootId);
    const builder = new dep_graph_1.DepGraphBuilder({ name: 'maven' }, parsedRoot.pkgInfo);
    const visitedMap = {};
    const queue = [];
    queue.push(...getItems(rootId, nodes[rootId]));
    // breadth first search
    while (queue.length > 0) {
        const item = queue.shift();
        if (!item)
            continue;
        const { id, parentId } = item;
        const parsed = parseId(id);
        const node = nodes[id];
        if (!includeTestScope && parsed.scope === 'test' && !node.reachesProdDep) {
            continue;
        }
        const visited = visitedMap[parsed.key];
        if (!verboseEnabled && visited) {
            const prunedId = visited.id + ':pruned';
            builder.addPkgNode(visited.pkgInfo, prunedId, {
                labels: { pruned: 'true' },
            });
            builder.connectDep(parentId, prunedId);
            continue; // don't queue any more children
        }
        const parentNodeId = parentId === rootId ? builder.rootNodeId : parentId;
        if (verboseEnabled && visited) {
            // use visited node when omited dependencies found (verbose)
            builder.addPkgNode(visited.pkgInfo, visited.id);
            builder.connectDep(parentNodeId, visited.id);
        }
        else {
            builder.addPkgNode(parsed.pkgInfo, id);
            builder.connectDep(parentNodeId, id);
            visitedMap[parsed.key] = parsed;
        }
        queue.push(...getItems(id, node));
    }
    return builder.build();
}
exports.buildDepGraph = buildDepGraph;
function getItems(parentId, node) {
    const items = [];
    for (const id of node?.dependsOn || []) {
        items.push({ id, parentId });
    }
    return items;
}
function parseId(id) {
    const dep = (0, dependency_1.parseDependency)(id);
    const maybeClassifier = dep.classifier ? `:${dep.classifier}` : '';
    const name = `${dep.groupId}:${dep.artifactId}`;
    return {
        id,
        key: `${name}:${dep.type}${maybeClassifier}`,
        pkgInfo: {
            name,
            version: dep.version,
        },
        scope: dep.scope,
    };
}
//# sourceMappingURL=dep-graph.js.map